import * as types from "./storyTypes";

const initialState = {
  /** storiesByUser[userId] = { items } — active 24h stories */
  storiesByUser: {},
  /** highlightsByUser[userId] = { items } — saved story categories */
  highlightsByUser: {},
  loadingList: false,
  loadingMutation: false,
  loadingHighlights: false,
  error: null,
};

export const userStoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_STORIES_BY_USER_REQUEST:
      return { ...state, loadingList: true, error: null };
    case types.FETCH_STORIES_BY_USER_SUCCESS: {
      const { userId, items } = action.payload;
      return {
        ...state,
        loadingList: false,
        storiesByUser: {
          ...state.storiesByUser,
          [userId]: { items: items ?? [] },
        },
      };
    }
    case types.FETCH_STORIES_BY_USER_FAIL:
      return { ...state, loadingList: false, error: action.payload };

    case types.CREATE_STORY_REQUEST:
    case types.DELETE_STORY_REQUEST:
      return { ...state, loadingMutation: true, error: null };
    case types.CREATE_STORY_SUCCESS: {
      const story = action.payload;
      const userId = story?.UserID?._id ?? story?.UserID ?? story?.userID;
      if (!userId) return { ...state, loadingMutation: false };
      const key = userId.toString?.() ?? userId;
      const prev = state.storiesByUser[key] ?? { items: [] };
      return {
        ...state,
        loadingMutation: false,
        storiesByUser: {
          ...state.storiesByUser,
          [key]: { items: [story, ...(prev.items || [])] },
        },
      };
    }
    case types.DELETE_STORY_SUCCESS: {
      const storyId = action.payload;
      const nextByUser = { ...state.storiesByUser };
      Object.keys(nextByUser).forEach((key) => {
        nextByUser[key] = {
          ...nextByUser[key],
          items: (nextByUser[key].items || []).filter(
            (s) =>
              (s._id?.toString?.() ?? s.id) !==
              (storyId?.toString?.() ?? storyId),
          ),
        };
      });
      return { ...state, loadingMutation: false, storiesByUser: nextByUser };
    }
    case types.CREATE_STORY_FAIL:
    case types.DELETE_STORY_FAIL:
      return { ...state, loadingMutation: false, error: action.payload };

    case types.RESET_STORIES_ERROR:
      return { ...state, error: null };

    case types.FETCH_HIGHLIGHTS_BY_USER_REQUEST:
      return { ...state, loadingHighlights: true, error: null };
    case types.FETCH_HIGHLIGHTS_BY_USER_SUCCESS: {
      const { userId, items } = action.payload;
      const key = (userId ?? "").toString();
      return {
        ...state,
        loadingHighlights: false,
        highlightsByUser: {
          ...state.highlightsByUser,
          [key]: { items: items ?? [] },
        },
      };
    }
    case types.FETCH_HIGHLIGHTS_BY_USER_FAIL:
      return { ...state, loadingHighlights: false, error: action.payload };

    case types.CREATE_HIGHLIGHT_SUCCESS: {
      const highlight = action.payload;
      const userId = highlight?.UserID ?? highlight?.userID;
      if (!userId) return state;
      const key = userId.toString?.() ?? userId;
      const prev = state.highlightsByUser[key] ?? { items: [] };
      return {
        ...state,
        highlightsByUser: {
          ...state.highlightsByUser,
          [key]: { items: [...(prev.items || []), highlight] },
        },
      };
    }
    case types.UPDATE_HIGHLIGHT_SUCCESS: {
      const updated = action.payload;
      const userId = updated?.UserID ?? updated?.userID;
      if (!userId) return state;
      const key = userId.toString?.() ?? userId;
      const prev = state.highlightsByUser[key]?.items ?? [];
      return {
        ...state,
        highlightsByUser: {
          ...state.highlightsByUser,
          [key]: {
            items: prev.map((h) =>
              (h._id ?? h.id) === (updated._id ?? updated.id) ? updated : h,
            ),
          },
        },
      };
    }
    case types.DELETE_HIGHLIGHT_SUCCESS: {
      const highlightId = action.payload;
      const next = { ...state.highlightsByUser };
      Object.keys(next).forEach((key) => {
        next[key] = {
          ...next[key],
          items: (next[key].items || []).filter(
            (h) =>
              (h._id ?? h.id)?.toString() !== (highlightId ?? "").toString(),
          ),
        };
      });
      return { ...state, highlightsByUser: next };
    }
    case types.ADD_STORY_TO_HIGHLIGHT_SUCCESS: {
      const updated = action.payload;
      const userId = updated?.UserID ?? updated?.userID;
      if (!userId) return state;
      const key = userId.toString?.() ?? userId;
      const prev = state.highlightsByUser[key]?.items ?? [];
      return {
        ...state,
        highlightsByUser: {
          ...state.highlightsByUser,
          [key]: {
            items: prev.map((h) =>
              (h._id ?? h.id) === (updated._id ?? updated.id) ? updated : h,
            ),
          },
        },
      };
    }

    default:
      return state;
  }
};
